export
const name: string = "Lines";

export
const preproc: string = ``;

export
const declaration: string = `
    // override default precision specified in defaultPrecision_fs
    precision lowp float;
    precision lowp int;

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)
    uniform SMaterial u_material;
    #endif

    #if !defined(PRIMITIVE_ID_PASS)
    uniform int u_line_type;
    #endif
`;

export
const varyings: string = `
    #if defined(PRIMITIVE_ID_PASS)
    varying vec4 v_primitive_id;
    #else
    varying mediump float v_distance_from_origin;
    #endif

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)
    varying         float v_selected;
    #endif
`;

export
const implementation: string = `
    void main()
    {
        // -1: full line, -256: dashed line
    #if !defined(PRIMITIVE_ID_PASS)
        if (u_line_type == -256 && fract(v_distance_from_origin * 2.0 / 2.0) > 0.5) discard;
    #endif

    #ifdef CLIPPING_PLANE
        if (resolveClippingPlane()) {
            #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)
            gl_FragColor = vec4(clippingPlaneColor, 1.0);
            return;
            #endif
        }
    #endif

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)

        SMaterial material = u_material;
        if (v_selected > 0.5) {
            material.ambient = SELECTED_MATERIAL_AMBIENT;
            material.diffuse = u_selected_material_diffuse;
        }

        gl_FragColor = applyLighting(material);

        #ifdef LOGDEPTH

        resolveLogarithmicDepth();

        #endif
    #endif

    #if defined(DEPTH_PASS)
        // HACK!!! the assigning of the fragCoord.z value to z is needed for iPhone6 :-)
        float z = gl_FragCoord.z;
        gl_FragColor = floatToVec4(z);
    #endif

    #if defined(PRIMITIVE_ID_PASS)
        gl_FragColor = v_primitive_id;
    #endif
    }
`;
